export const HITL_FEATURE_FLAG = "hitl";

export function isHitlEnabled(featureFlags?: string[] | null): boolean {
  return (featureFlags ?? []).includes(HITL_FEATURE_FLAG);
}

export function getAwaitingInputRoute(
  reportId: string | null | undefined,
  hitlEnabled: boolean
): string {
  if (!reportId) {
    return "/";
  }

  const encodedReportId = encodeURIComponent(reportId);

  return hitlEnabled
    ? `/review-plan/${encodedReportId}`
    : `/preview-report-info/${encodedReportId}`;
}

export function getAwaitingInputActionLabel(hitlEnabled: boolean): string {
  return hitlEnabled ? "Review Outline" : "View Report";
}

export function getAwaitingInputDescription(hitlEnabled: boolean): string {
  return hitlEnabled
    ? "Open the review outline to continue the workflow."
    : "Open the report to continue the workflow.";
}

export function getAwaitingInputAriaLabel(hitlEnabled: boolean): string {
  return hitlEnabled ? "Review pending outline" : "View report awaiting input";
}
